
import device from 'bits/device'
import { navigateTo } from 'bits/location'
import { Component, namespace, Vue } from 'bits/vue'
import OzMenuRows, { OzMenuRowsFocusStyle, OzMenuRowsSizePreset } from 'library/v4/components/OzMenuRows.vue'
import { OzBoxColors } from 'library/v4/components/OzPopoverModal.vue'
import OzScreenSizeAwarePopoverModal from 'library/v4/components/OzScreenSizeAwarePopoverModal.vue'
import LocaleMenu from 'vuecomponents/LocaleMenu.vue'

enum AuthActionType {
  Help = 'Help',
  Accessibility = 'Accessibility',
  LocaleMenu = 'LocaleMenu',
}

const HELP_URL = 'https://padlet.help'
const ACCESSIBILITY_URL = 'https://padlet.com/about/accessibility'

const localeStore = namespace('locale')
const browserStore = namespace('browser')

@Component({
  components: {
    LocaleMenu,
    OzMenuRows,
    OzScreenSizeAwarePopoverModal,
  },
})
export default class AuthActionMenu extends Vue {
  // This component comes as a pair with the vuexstore/modules/locale.ts.
  // Items from other parts of the vuex store should be passed in as props.
  @localeStore.State isSelectorOpen!: boolean
  @localeStore.State currentLocale!: string
  @localeStore.Getter currentLocaleName!: string
  @localeStore.Action openLocaleMenu!: () => void
  @localeStore.Action closeLocaleMenu!: () => void
  @localeStore.Action changeLocale!: (lang: string) => Promise<void>
  @browserStore.Getter isSmallerThanTabletPortrait!: boolean
  @browserStore.Getter windowHeight!: number

  OzBoxColors = OzBoxColors
  OzMenuRowsFocusStyle = OzMenuRowsFocusStyle
  OzMenuRowsSizePreset = OzMenuRowsSizePreset

  get menuActions() {
    return [
      {
        text: this.__('Help'),
        eventPayload: AuthActionType.Help,
        href: HELP_URL,
      },
      {
        text: this.__('Accessibility'),
        eventPayload: AuthActionType.Accessibility,
        href: ACCESSIBILITY_URL,
      },
      {
        text: this.__('Language'),
        eventPayload: AuthActionType.LocaleMenu,
        rightIcon: 'chevron_right_center',
        rightIconSize: 16,
        rightLabel: this.currentLocaleName,
        testId: 'localeMenuButtonActionMenu',
      },
    ]
  }

  onSelectMenuRow(_event, eventPayload: AuthActionType) {
    switch (eventPayload) {
      case AuthActionType.Help:
        navigateTo(HELP_URL, { target: '_blank' })
        break
      case AuthActionType.Accessibility:
        navigateTo(ACCESSIBILITY_URL, { target: '_blank' })
        break
      case AuthActionType.LocaleMenu:
        this.openLocaleMenu()
    }
  }

  get isPhone(): boolean {
    return device.phone || this.isSmallerThanTabletPortrait
  }

  cancel(): void {
    this.closeLocaleMenu()
    this.$emit('cancel')
  }

  async handleChangeLocale(lang: string): Promise<void> {
    await this.changeLocale(lang)
    this.$emit('change-locale')
  }
}
